import { render, staticRenderFns } from "./robotConsult.vue?vue&type=template&id=de4467cc&scoped=true&"
import script from "./robotConsult.js?vue&type=script&lang=js&"
export * from "./robotConsult.js?vue&type=script&lang=js&"
import style0 from "./robotConsult.css?vue&type=style&index=0&id=de4467cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4467cc",
  null
  
)

export default component.exports